import React from "react";
import { User, Phone, MapPin, History, ChevronDown, ShoppingCart, BarChart3, Sparkles } from "lucide-react";
import { CORES, CLIENTE, iniciais } from "./dadosMockup";

// Painel direito real no cenario Delivery (DeliveryRightPanel):
// PanelHeader + Detalhes do Cliente + grade de ferramentas.
const DETALHES = [
  { Icone: User, rotulo: "Nome", valor: CLIENTE.nome },
  { Icone: Phone, rotulo: "Telefone", valor: CLIENTE.telefone },
  { Icone: MapPin, rotulo: "Endereço", valor: CLIENTE.endereco },
  { Icone: History, rotulo: "Último Pedido", valor: CLIENTE.ultimoPedido },
];

const FERRAMENTAS = [
  { Icone: ShoppingCart, rotulo: "Novo Pedido", fundo: "rgba(6,78,59,0.3)", cor: "#34d399" },
  { Icone: MapPin, rotulo: "Calcular Taxa", fundo: "rgba(124,45,18,0.3)", cor: "#fb923c" },
  { Icone: BarChart3, rotulo: "Insights", fundo: "rgba(88,28,135,0.3)", cor: "#c084fc" },
];

export default function PainelCliente() {
  return (
    <aside className="flex flex-col h-full" style={{ background: "#111111", borderLeft: `1px solid ${CORES.borda}` }}>
      {/* PanelHeader */}
      <div className="flex items-center gap-3 h-20 p-4 shrink-0">
        <div className="w-11 h-11 rounded-2xl flex items-center justify-center text-white font-bold text-sm bg-gradient-to-br from-violet-500 to-purple-600">
          {iniciais(CLIENTE.nome)}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold truncate" style={{ color: CORES.texto }}>{CLIENTE.nome}</div>
          <div className="text-xs text-emerald-600">cliente vinculado</div>
        </div>
        <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-violet-100/70 text-violet-700">
          {CLIENTE.pedidos}
        </span>
      </div>

      {/* Detalhes do Cliente */}
      <div className="px-4">
        <div className="flex items-center justify-between py-2">
          <span className="text-sm font-semibold" style={{ color: CORES.texto }}>Detalhes do Cliente</span>
          <ChevronDown className="w-4 h-4" style={{ color: CORES.textoMuted }} />
        </div>
        <div className="rounded-2xl p-3 space-y-2.5" style={{ background: CORES.card, border: `1px solid ${CORES.borda}` }}>
          {DETALHES.map(({ Icone, rotulo, valor }) => (
            <div key={rotulo} className="flex items-start gap-2 text-xs leading-snug">
              <Icone className="w-3.5 h-3.5 mt-0.5 shrink-0" style={{ color: CORES.textoMuted }} />
              <span style={{ color: CORES.textoMuted }}>
                {rotulo}: <span style={{ color: CORES.texto }}>{valor}</span>
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Ferramentas (ToolButton) */}
      <div className="grid grid-cols-3 gap-2 px-4 mt-4">
        {FERRAMENTAS.map(({ Icone, rotulo, fundo, cor }) => (
          <div
            key={rotulo}
            className="flex flex-col items-center gap-2 p-3 rounded-2xl text-center"
            style={{ background: CORES.card, border: "1px solid rgba(255,255,255,0.15)" }}
          >
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: fundo }}>
              <Icone className="w-5 h-5" style={{ color: cor }} />
            </div>
            <span className="text-xs leading-tight" style={{ color: CORES.texto }}>{rotulo}</span>
          </div>
        ))}
      </div>

      {/* Area dinamica — estado vazio */}
      <div className="flex-1 flex flex-col items-center justify-center gap-2 px-6 text-center">
        <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: CORES.muted }}>
          <Sparkles className="w-5 h-5" style={{ color: CORES.textoMuted }} />
        </div>
        <span className="text-xs" style={{ color: CORES.textoMuted }}>Selecione uma ferramenta acima</span>
      </div>
    </aside>
  );
}
